export const sleep = (milliseconds: number) =>
  new Promise((rs) => setTimeout(() => rs(""), milliseconds));
